var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { ValidationError } from "yup";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetchLoginSource } from "../../services/authQueries";
import { registerValidationSchema, registerValidationSchemaNoPassConfirm, } from "./validations";
import axios from "axios";
import { Verify } from "./Verify";
import { PasswordValidator, buildLowercaseValidation, buildMinLengthValidation, buildNumberValidation, buildSpecialCharacterValidation, buildUppercaseValidation, } from "../../components/Elements/PasswordValidator";
import { Button, LinkButton } from "../../components/Elements/Button";
var COMPANY_ROLE_OTHER = "Other";
var COMPANY_ROLES = [
    "Project executive",
    "Project manager",
    "Project administrator",
    "Operations manager",
    "Lawyer/Counsel",
    "Paralegal",
    "Risk manager",
    "Administrative support",
    "Architect",
    "Engineer",
    "Estimator",
    "Procurement",
    "Field operations / Superintendent",
    "Quality",
    "Safety professional",
    "Business development / Sales",
    COMPANY_ROLE_OTHER,
];
export var Register = function (_a) {
    var inviteToken = _a.inviteToken, invitedEmail = _a.invitedEmail, shareToEmail = _a.shareToEmail, passwordRequirementsJSON = _a.passwordRequirementsJSON, rolloutNewPasswordFieldFlag = _a.rolloutNewPasswordFieldFlag, teamsInvitedTo = _a.teamsInvitedTo, onCancel = _a.onCancel;
    var _b = useState(invitedEmail), email = _b[0], setEmail = _b[1];
    var _c = useState(""), firstName = _c[0], setFirstName = _c[1];
    var _d = useState(""), lastName = _d[0], setLastName = _d[1];
    var _e = useState(""), companyRole = _e[0], setCompanyRole = _e[1];
    var _f = useState(""), otherRole = _f[0], setOtherRole = _f[1];
    var _g = useState(""), password = _g[0], setPassword = _g[1];
    var _h = useState(""), confirmPassword = _h[0], setConfirmPassword = _h[1];
    var _j = useState(false), agree = _j[0], setAgree = _j[1];
    var _k = useState([]), errors = _k[0], setErrors = _k[1];
    var _l = useState(false), submitting = _l[0], setSubmitting = _l[1];
    var _m = useState(false), isVerified = _m[0], setIsVerified = _m[1];
    var _o = useState(""), successMessage = _o[0], setSuccessMessage = _o[1];
    var _p = useState(""), successTitle = _p[0], setSuccessTitle = _p[1];
    var _q = useState(false), validForm = _q[0], setValidForm = _q[1];
    var _r = useState(false), seePassword = _r[0], setSeePassword = _r[1];
    var _s = useState("native"), loginSource = _s[0], setLoginSource = _s[1];
    var _t = useState(false), showPasswordRequirements = _t[0], setShowPasswordRequirements = _t[1];
    useEffect(function () {
        var setInitialEmail = function () {
            if (invitedEmail) {
                setEmail(invitedEmail);
            }
            else if (shareToEmail) {
                setEmail(shareToEmail);
            }
        };
        var setInitialLoginSource = function (email) { return __awaiter(void 0, void 0, void 0, function () {
            var source, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchLoginSource(email)];
                    case 1:
                        source = _a.sent();
                        setLoginSource(source);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        setInitialEmail();
        setInitialLoginSource(email);
    }, [invitedEmail, shareToEmail]);
    useEffect(function () {
        // Automatically set the password if the login source is SSO
        if (loginSource === "sso") {
            setPassword(generateRandomString(24));
        }
    }, [loginSource]);
    var formValues = function () {
        return {
            firstName: firstName,
            lastName: lastName,
            jobTitle: companyRole === ""
                ? null
                : companyRole === COMPANY_ROLE_OTHER
                    ? otherRole
                    : companyRole,
            password: password,
            confirmPassword: confirmPassword,
            email: email,
            agree: agree,
            inviteToken: inviteToken,
        };
    };
    var generateRandomString = function (length) {
        var upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lowerCase = "abcdefghijklmnopqrstuvwxyz";
        var numbers = "0123456789";
        var symbols = "!@#$%^&*()_+";
        var allCharacters = upperCase + lowerCase + numbers + symbols;
        var result = "";
        result += upperCase.charAt(Math.floor(Math.random() * upperCase.length));
        result += lowerCase.charAt(Math.floor(Math.random() * lowerCase.length));
        result += numbers.charAt(Math.floor(Math.random() * numbers.length));
        result += symbols.charAt(Math.floor(Math.random() * symbols.length));
        for (var i = 4; i < length; i++) {
            result += allCharacters.charAt(Math.floor(Math.random() * allCharacters.length));
        }
        return result
            .split("")
            .sort(function () { return 0.5 - Math.random(); })
            .join("");
    };
    var onRegisterSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var responseRegister, _a, isVerified_1, message, title, redirectFromRegister, response, redirectUrl, err_2, err_3, errors_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.preventDefault();
                    setSubmitting(true);
                    setErrors([]);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 13, 14, 15]);
                    if (!!rolloutNewPasswordFieldFlag) return [3 /*break*/, 3];
                    return [4 /*yield*/, registerValidationSchema.validate(formValues(), {
                            abortEarly: false,
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, registerValidationSchemaNoPassConfirm.validate(formValues(), {
                        abortEarly: false,
                    })];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [4 /*yield*/, axios.post("/ajax/register", {
                        user: formValues(),
                    })];
                case 6:
                    responseRegister = _b.sent();
                    _a = responseRegister.data, isVerified_1 = _a.isVerified, message = _a.message, title = _a.title, redirectFromRegister = _a.redirect;
                    logFSEvent();
                    setIsVerified(isVerified_1);
                    if (!isVerified_1) return [3 /*break*/, 11];
                    _b.label = 7;
                case 7:
                    _b.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, axios.post("/ajax/login/check", {
                            username: email,
                            password: password,
                        }, {
                            headers: { "Content-Type": "application/json" },
                        })];
                case 8:
                    response = _b.sent();
                    redirectUrl = response.data.redirectUrl;
                    location.href = redirectUrl || redirectFromRegister || "/";
                    return [3 /*break*/, 10];
                case 9:
                    err_2 = _b.sent();
                    location.href = "/";
                    setErrors(["There was an error logging you in. Please try again."]);
                    return [3 /*break*/, 10];
                case 10: return [3 /*break*/, 12];
                case 11:
                    setSuccessMessage(message);
                    setSuccessTitle(title);
                    _b.label = 12;
                case 12: return [3 /*break*/, 15];
                case 13:
                    err_3 = _b.sent();
                    if (err_3 instanceof ValidationError) {
                        setErrors(err_3.errors);
                    }
                    else {
                        errors_1 = err_3.response.data.errors;
                        setErrors(errors_1);
                    }
                    return [3 /*break*/, 15];
                case 14:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var renderErrorAlert = function () {
        var errorMessages = errors.map(function (error, idx) {
            return _jsx("li", { children: error }, idx);
        });
        return (_jsxs("div", __assign({ className: "alert alert-danger my-5", role: "alert" }, { children: [_jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close", onClick: function () { return setErrors([]); } }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) })), _jsx("ul", __assign({ className: "list-unstyled" }, { children: errorMessages }))] })));
    };
    var renderVerify = function () {
        return (_jsx(Verify, { title: successTitle, isVerified: isVerified, message: successMessage }));
    };
    var logFSEvent = function () {
        var _a;
        (_a = window.FS) === null || _a === void 0 ? void 0 : _a.call(window, "trackEvent", {
            name: "Login",
        });
    };
    var renderSharingAlert = function () {
        return (_jsxs("div", __assign({ className: "alert alert-success my-5 d-flex", role: "alert" }, { children: ["A Crunch was shared with you! Please create an account in order to view it.", _jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close" }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))] })));
    };
    var renderInviteAlert = function () {
        return (_jsxs("div", __assign({ className: "alert alert-success my-5", role: "alert" }, { children: ["You have been invited to join a team. Please sign up!", _jsx("button", __assign({ type: "button", className: "close", "data-dismiss": "alert", "aria-label": "Close" }, { children: _jsx("span", __assign({ "aria-hidden": "true" }, { children: "\u00D7" })) }))] })));
    };
    var emailIsReadOnly = function () {
        return invitedEmail !== null || shareToEmail !== null;
    };
    var renderPasswordRequirements = function () {
        var passwordRequirements = JSON.parse(passwordRequirementsJSON);
        var validationRules = [];
        if (passwordRequirements["MinimumLength"]) {
            validationRules.push(buildMinLengthValidation(passwordRequirements["MinimumLength"]));
        }
        if (passwordRequirements["RequireUppercase"]) {
            validationRules.push(buildUppercaseValidation());
        }
        if (passwordRequirements["RequireLowercase"]) {
            validationRules.push(buildLowercaseValidation());
        }
        if (passwordRequirements["RequireNumbers"]) {
            validationRules.push(buildNumberValidation());
        }
        if (passwordRequirements["RequireSymbols"]) {
            validationRules.push(buildSpecialCharacterValidation());
        }
        return (_jsx(PasswordValidator, { password: password, confirmPassword: confirmPassword, validationRules: validationRules, onValidate: function (isValid) {
                setValidForm(isValid);
            } }));
    };
    var renderNewWelcomeMessage = function () {
        var humanReadTeamNames = (teamsInvitedTo === null || teamsInvitedTo === void 0 ? void 0 : teamsInvitedTo.length) &&
            teamsInvitedTo.reduce(function (stringSum, teamName, idx) {
                if (idx === 0) {
                    return "".concat(teamName);
                }
                else if (idx === teamsInvitedTo.length - 1) {
                    return "".concat(stringSum, " and ").concat(teamName);
                }
                else {
                    return "".concat(stringSum, ", ").concat(teamName);
                }
            }, "");
        if (invitedEmail && (teamsInvitedTo === null || teamsInvitedTo === void 0 ? void 0 : teamsInvitedTo.length)) {
            return (_jsxs("div", __assign({ className: "my-10 d-flex justify-content-center" }, { children: ["You've been invited to join the ", humanReadTeamNames, " team", teamsInvitedTo.length > 1 ? "s" : ""] })));
        }
        else if (invitedEmail && !(teamsInvitedTo === null || teamsInvitedTo === void 0 ? void 0 : teamsInvitedTo.length)) {
            return (_jsx("div", __assign({ className: "my-10 d-flex justify-content-center text-danger" }, { children: "The invitation you were sent is no longer valid, but you can still create your account. To gain team access, please reach out to the sender and request a new invitation." })));
        }
        return null;
    };
    var renderPasswordField = function () {
        return (_jsxs("div", __assign({ className: "form-group mb-5 position-relative" }, { children: [_jsx("input", { onFocus: function () { return setShowPasswordRequirements(true); }, className: "form-control h-auto form-control-solid py-4 px-8", type: seePassword ? "text" : "password", placeholder: "Password", name: "password", onChange: function (e) { return setPassword(e.target.value); }, value: password }), rolloutNewPasswordFieldFlag && (_jsx(ShowPasswordDiv, __assign({ className: "input-group-append position-absolute right-0 top-0 mt-3 mr-2" }, { children: _jsx("span", __assign({ className: "input-group-text border-0", onClick: function () { return setSeePassword(!seePassword); } }, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, icon: seePassword ? faEyeSlash : faEye }) })) })))] })));
    };
    var renderForm = function () {
        return (_jsxs(_Fragment, { children: [errors.length > 0 && renderErrorAlert(), shareToEmail && renderSharingAlert(), renderNewWelcomeMessage(), _jsxs("form", __assign({ action: "/register", className: "form", method: "post", onSubmit: onRegisterSubmit }, { children: [_jsx("input", { type: "hidden", name: "user[groups][]", value: "2" }), _jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { className: "form-control h-auto form-control-solid py-4 px-8", type: "text", placeholder: "First Name", name: "profile[firstName]", onChange: function (e) { return setFirstName(e.target.value); }, value: firstName }) })), _jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { className: "form-control h-auto form-control-solid py-4 px-8", type: "text", placeholder: "Last Name", name: "profile[lastName]", onChange: function (e) { return setLastName(e.target.value); }, value: lastName }) })), _jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { id: "dc-user-email-signin", className: "form-control h-auto form-control-solid py-4 px-8", type: "text", placeholder: "Email", name: "user[email]", autoComplete: "off", onChange: function (e) { return setEmail(e.target.value); }, value: email, readOnly: emailIsReadOnly() }) })), _jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsxs(StyledSelect, __assign({ className: "form-control h-auto form-control-solid py-4 px-8", name: "profile[jobTitle]", onChange: function (e) { return setCompanyRole(e.target.value); }, value: companyRole, "$isPlaceholder": companyRole === "" }, { children: [_jsx("option", __assign({ value: "" }, { children: "Select your company role" })), COMPANY_ROLES.map(function (role) { return (_jsx("option", __assign({ value: role }, { children: role }), role)); })] })) })), companyRole === COMPANY_ROLE_OTHER && (_jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { className: "form-control h-auto form-control-solid py-4 px-8", type: "text", placeholder: "Specify your role", name: "profile[otherRole]", onChange: function (e) { return setOtherRole(e.target.value); }, value: otherRole }) }))), loginSource === "sso" ? null : renderPasswordField(), !rolloutNewPasswordFieldFlag && (_jsx("div", __assign({ className: "form-group mb-5" }, { children: _jsx("input", { className: "form-control h-auto form-control-solid py-4 px-8", type: "password", placeholder: "Confirm Password", name: "cpassword", onChange: function (e) { return setConfirmPassword(e.target.value); }, value: confirmPassword }) }))), showPasswordRequirements && renderPasswordRequirements(), _jsxs("div", __assign({ className: "form-group mb-5 text-left" }, { children: [_jsx("div", __assign({ className: "checkbox-inline" }, { children: _jsxs("label", __assign({ className: "checkbox m-0" }, { children: [_jsx(TermsOfServiceCheckbox, { type: "checkbox", name: "agree", onChange: function (e) { return setAgree(e.target.checked); }, checked: agree }), _jsx("span", {}), "I agree to the", _jsx(LinkButton, __assign({ linkType: "plain", href: "https://www.documentcrunch.com/terms-of-service", target: "_blank", className: "font-weight-bold ml-1", rel: "noreferrer" }, { children: "Terms of Service" })), "."] })) })), _jsx("div", { className: "form-text text-muted text-center" })] })), _jsx("div", __assign({ className: "form-group d-flex flex-wrap flex-center mt-10" }, { children: _jsx(Button, __assign({ id: "kt_login_signup_submit", buttonType: "primary", className: "btn font-weight-bold px-9 py-4 my-3 mx-4", disabled: submitting || (!validForm && loginSource !== "sso") }, { children: submitting ? (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm", role: "status", "aria-hidden": "true" }), _jsx("span", __assign({ className: "ml-1" }, { children: "Creating..." }))] })) : (_jsx("span", { children: "Create account" })) })) }))] }))] }));
    };
    return (_jsxs("div", __assign({ className: "login-signup-on" }, { children: [_jsx("div", __assign({ className: "".concat(invitedEmail && !shareToEmail ? "my-10" : "my-20") }, { children: _jsx("h3", { children: "Welcome to Document Crunch" }) })), renderForm()] })));
};
var TermsOfServiceCheckbox = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:checked ~ span {\n    background-color: #1867be !important;\n  }\n"], ["\n  &:checked ~ span {\n    background-color: #1867be !important;\n  }\n"])));
// This element is mostly styled with the bootstrap classes
// but we need to override the hover cursor
var ShowPasswordDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  :hover {\n    cursor: pointer;\n  }\n"], ["\n  :hover {\n    cursor: pointer;\n  }\n"])));
// Styled select component to provide proper dropdown arrow spacing
var StyledSelect = styled.select(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &.form-control.h-auto.form-control-solid.py-4.px-8 {\n    padding-right: 3rem !important;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.75rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5em 1.5em;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    color: ", ";\n  }\n"], ["\n  &.form-control.h-auto.form-control-solid.py-4.px-8 {\n    padding-right: 3rem !important;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.75rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5em 1.5em;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    color: ", ";\n  }\n"])), function (props) {
    return props.$isPlaceholder ? "rgba(63, 66, 84, 0.4)" : "#3f4254";
});
var templateObject_1, templateObject_2, templateObject_3;
